import { createSlice } from '@reduxjs/toolkit';

export const alertReducer = createSlice({
    name: 'alert',
    initialState: {
        timedContent: null,
        open: false,
        severity: 'error',
        timedSeverity: 'error',
        content: 'This is an error message!'
    },
    reducers: {
        setAlertProps: (state, action) => {
            const props = action?.payload;
            Object.keys(props).forEach(key => {
                state[key] = props[key];
            });
        },
        setAlertOpen: (state, action) => {
            state.open = action?.payload;
        },
        setTimedContent: (state, action) => {
            if (action?.payload?.severity) {
                state.timedSeverity = action?.payload.severity;
                state.timedContent = action?.payload.content;
            } else {
                state.timedSeverity = 'error';
                state.timedContent = action?.payload;
            }
        }
    }
});

// Action creators are generated for each case reducer function
export const { setAlertProps, setAlertOpen, setTimedContent } = alertReducer.actions;

export default alertReducer.reducer;
